// extracted by css-extract-rspack-plugin
export default {"codeBlockTextArea":"EbvxO","placeholder":"qoU3i","borderRadius":"x0w5I","closeButton":"HsEI0","contentWrapper":"DU7vi","iconShrink":"iN0Uf"};